export const VoteMap = [
    {voteId: 1,
    voteName: 'vote1',
	memShortTitle: 'Rep',	
	body: 'house',
    congress: 117,
    session: 1,
	rollCall: 369,
    voteDesc: 'iija'},
    {voteId: 2,
    voteName: 'vote2',
	memShortTitle: 'Rep',	
	body: 'house',
    congress: 117,
    session: 2,
	rollCall: 420,
    voteDesc: 'inflation reduction'},
    {voteId: 3,
    voteName: 'vote3',
	memShortTitle: 'Rep',	
	body: 'house',
    congress: 117,
    session: 2,
	rollCall: 404,
    voteDesc: 'chips'},
    {voteId: 4,
    voteName: 'vote4',
	memShortTitle: 'Rep',	
	body: 'house',
    congress: 118,
    session: 1,
	rollCall: 243,
    voteDesc: 'fiscal responsibility'},
    {voteId: 5,
    voteName: 'vote1',
    memShortTitle: 'Sen',	
    body: 'senate',
    congress: 117,
    session: 1,
    rollCall: 314,
    voteDesc: 'iija'},
    {voteId: 6,
    voteName: 'vote2',
    memShortTitle: 'Sen',	
    body: 'senate',
    congress: 117,
    session: 2,
    rollCall: 325,
    voteDesc: 'inflation reduction'},
    {voteId: 7,
    voteName: 'vote3',
    memShortTitle: 'Sen',	
    body: 'senate',
    congress: 117,
    session: 2,
    rollCall: 271,
    voteDesc: 'chips'},
    {voteId: 8,
    voteName: 'vote4',
    memShortTitle: 'Sen',	
    body: 'senate',
    congress: 118,
    session: 1,
    rollCall: 146,
    voteDesc: 'fiscal responsibility'}
]
